import React from 'react';

export default function List({ magazineList }) {
  return (
    <div>
      {magazineList.length > 0 ? (
        <section className="section u--padding-bottom-0">
          <div className="container container--xl">
            <div className="grid grid--std grid--magazines">
              {magazineList.map((i) => (
                <div
                  key={i.id}
                  className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3"
                >
                  <article className="magazine__display">
                    <a href={i.issue_url}>
                      <div className="magazine__body">
                        <img
                          src={i.cover_image}
                          className="magazine__cover"
                          alt={`Texas Coop Issue ${i.issue_date}`}
                        />
                      </div>
                      <p className="magazine__issue-date">{i.issue_date}</p>
                    </a>
                  </article>
                </div>
              ))}
            </div>
            <hr className="section__hr" />
          </div>
        </section>
      ) : (
        ''
      )}
    </div>
  );
}
